// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1GMos","title":"Images90_title__2UCb3","images":"Images90_images__1Z7jD"};